import { type FeatureModule } from '@store/features/types';

export const payerDocsCenterFeature: FeatureModule = {
  id: 'payerDocsCenter',
  name: 'Payer Docs Center',
  dependencies: [],
  reducers: {},
  middleware: [],
  persistence: { enabled: false },
  sync: { enabled: false },
  setup: _store => {},
  cleanup: _store => {},
};
